<template>
  <div class="user_container">
    <div class="user-top">
      <h1 style="font-size: 30px; font-weight: 700">雷士打车平台</h1>
      <div style="margin-top: 8px">为员工提供更便捷的</div>
      <div style="">新政出行福利体验~</div>
    </div>
    <div class="user-nav">
      <div style="height: 60px">
        <img
          style="
            position: absolute;
            top: -6%;
            left: 10%;
            width: 96px;
            height: 102px;
          "
          src="../../../assets/car/iconHead.png"
          alt=""
          srcset=""
        />
        <div class="search">
          <!-- 区域筛选 -->
          <el-select
            v-model="valueCity"
            placeholder="请选择"
            @change="changeCity"
          >
            <el-option
              v-for="item in optionCity"
              :key="item.id"
              :label="item.zoneName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- 收藏&不收藏 -->
          <img
            src="@/assets/car/xing.png"
            alt=""
            v-if="!flagImg"
            @click="setCollect1"
          />
          <img
            src="@/assets/car/xingActive.png"
            alt=""
            v-if="flagImg"
            @click="setCollect2"
          />
        </div>
      </div>
      <div class="tit">
        <div>用车注意事项：</div>
        <!-- <div>1、出行请优先使用公务车;</div>
        <div>
          2、签约主体在xxx、xxxxx、xxxx内的职员享有滴滴出行、易企出行的打车福利
        </div>
        <div>3、享有打车补贴的驻外同事不享有打车福利</div> -->
        <div>1、雷士公务用车实行线上预约，以提高公车申请和使用效率</div>
        <div>2、公务用车实行“先审批、后使用”，经部门负责人审批后方能申请</div>
        <div>3、提倡相同目的地或近似方向的同事拼车出行，降低出行成本</div>
        <div>4、试运行期间的任何问题请与常务安全经理王启孝反馈沟通</div>
      </div>
      <div class="flex car-foot">
        <div style="width: 100%" v-for="item in list" :key="item.name">
          <div
            class="car-foot-nav flex"
            @click="jumpLink(item)"
            v-show="item.isShow"
          >
            <img :src="item.img" alt="" srcset="" />
            <div style="font-weight: 700; font-size: 16px">{{ item.name }}</div>
            <div class="jt">
              <i
                style="font-size: 26px; font-weight: 700"
                class="iconfont icon-arrow-right-copy-copy"
              ></i>
            </div>
          </div>
        </div>
        <div>
          <img style="width: 100%" src="../../../assets/car/car4.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
// import apis from "@/apis/medal";
import apisCar from "@/apis/car";

import { getToken, setToken } from "@/utils/cookie";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      list: [],
      valueCity: "",
      optionCity: [],
      flagImg: false,
      userinfo: {},
    };
  },
  created() {},
  mounted() {
    //获取token
    let token = getToken();
    if (token) {
      // 获取区域列表
      this.getType(token);
    } else {
       //获取token
      this.$bus.$on("processToken", (res) => {
          // 获取区域列表
        this.getType(res);
      });
    }
  },
  methods: {
    // 获取跳转权限
    jumpLink(item) {
      localStorage.setItem("cityId", this.valueCity);
      if (item.name == "厂务管理") {
        const user = this.userinfo.zones;
        if (user && user.includes(this.valueCity)) {
          this.$router.push(item.path);
        } else {
          this.$message.warning("您无此权限");
        }
      } else if (item.name == "公务车预约") {
        this.$router.push(
          `/car/official/index?isShowUserId=false&isShowTabs=false&zoneId=${this.valueCity}`
        );
      } else {
        this.$router.push(item.path);
      }
    },
    // 获取区域列表
    getType(token) {
      apisCar
        .queryCarZoneByPageList({
          pageSize: "999",
          page: 1,
        })
        .then((data) => {
          if (data.code == 200) {
            this.optionCity = data.data;
            this.getUserToken(token);
          }
        });
    },
    // 区域筛选
    changeCity(val) {
      if (val == this.userinfo.carZone) {
        this.flagImg = true;
      } else {
        this.flagImg = false;
      }
    },
    // 收藏和取消收藏
    setCollect(status) {
      let token = getToken();
      const carZone = status ? this.valueCity : 0;
      const message = status ? "收藏成功" : "取消收藏成功";
      const flagState = status ? true : false;

      apisCar
        .updateUserZoneId({
          empno: token,
          carZone: carZone,
        })
        .then((data) => {
          if (data.code == 200) {
            this.$message({
              type: "success", // success error warning
              message: message,
              duration: 2000,
            });
            this.flagImg = flagState;
            this.getUserToken(token);
          }
        });
    },
    setCollect1() {
      this.setCollect(true); // 收藏操作
    },
    setCollect2() {
      this.setCollect(false); // 取消收藏操作
    },
    //获取用户信息，获取权限
    getUserToken(empNo) {
      if (empNo) {
        let thisname = empNo;
        api.queryByUsername({ username: thisname }).then((data) => {
          const info = data.data;
          this.userinfo = info;
          console.log(info, "info");
          if (info.carZone) {
            this.valueCity = info.carZone;
            this.flagImg = true;
          } else {
            this.flagImg = false;
            this.valueCity = 1;
          }
          // this.$store.commit("changeUserInfo", info);
          setToken(empNo);
          console.log(this.valueCity, "valueCity");
          //isShowUserId 是否显示申请用车工号输入框
          //isShowTabs 是否显示可预约 使用中 下拉框
          this.list = [
            {
              img: require("@/assets/car/car1.png"),
              name: "公务车预约",
              path: `/car/official/index?isShowUserId=false&isShowTabs=false&zoneId=${this.valueCity}`,
              isShow: info.carAdmin != null ? true : false,
            },
            {
              img: require("@/assets/car/car2.png"),
              name: "厂务管理",
              path: "/car/facility/index",
              isShow: info.carAdmin == "1" ? true : false, //0 不显示 1 显示
            },
            {
              img: require("@/assets/car/car3.png"),
              name: "司机管理",
              path: "/car/driver/index",
              isShow: info.car == "0" ? true : false, //0 显示 1 不显示
            },
          ];
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  min-height: 100vh;
  padding: 30px;
  margin: auto;
  font-size: 1vh;
  background-image: url("~@/assets/car/homeBG.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 26px;

  .user-top {
    color: #fff;
    margin: 100px 0 100px 0;
  }

  .user-nav {
    position: relative;
    // height: 80vh;
    background-color: #fff;
    padding: 0 20px;
    border-radius: 10px;
    .search {
      position: absolute;
      right: 20px;
      top: 25px;
      display: flex;
      align-items: center;
      ::v-deep {
        .el-input {
          width: 200px;
        }
        .el-input__inner {
          height: 60px;
          background: rgba(243, 244, 247, 1);
          border: none;
          border-radius: 10px;
        }
      }
      img {
        // width: 50px;
        // height: 44px;
        margin-left: 20px;
      }
    }
  }

  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .car-foot-nav {
    width: 100%;
    background: rgb(243 245 249);
    border-radius: 10px;
    // line-height: 30px;
    padding: 10px;
    margin: 40px 0 0 0;
    padding: 2vh;
  }

  .jt {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background-color: #fff;
    text-align: center;
    line-height: 50px;
  }

  .tit {
    line-height: 45px;
    background: rgb(243 245 249);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
  }
}
</style>
